import React from "react";
import { Loader2, AlertTriangle, RefreshCw } from "lucide-react";

// Palette-correct load states (olive/amber — never purple). Used everywhere an async load can
// stall or fail so no surface is ever stuck on a spinner that can't exit.
export function Loading({ label = "Loading…", testid = "loading-state" }) {
  return (
    <div data-testid={testid} className="flex items-center gap-2 px-4 py-8 font-mono uppercase text-sm text-muted-foreground">
      <Loader2 className="w-4 h-4 animate-spin text-olive-bright" /> {label}
    </div>
  );
}

export function LoadFailed({ reason = "Something didn't load.", onRetry, testid = "load-failed" }) {
  return (
    <div data-testid={testid} className="max-w-lg mx-auto my-6 border border-[#C2600F]/50 bg-[#C2600F]/10 p-5">
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-[#E8A05A] mt-0.5 shrink-0" aria-hidden="true" />
        <div className="min-w-0">
          <p className="font-heading uppercase tracking-tight text-[#E8A05A] text-sm">Couldn't load</p>
          <p className="font-mono text-[12px] text-secondary-foreground mt-1 break-words">{reason}</p>
          {onRetry && (
            <button onClick={onRetry} data-testid="load-failed-retry"
              className="mt-3 inline-flex items-center gap-2 bg-[#57682A] hover:bg-[#748A3D] text-white font-heading font-bold uppercase text-xs px-4 py-2 transition-colors">
              <RefreshCw className="w-3.5 h-3.5" /> Retry
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default LoadFailed;
